import React, { useEffect, useState } from "react";
import { getMyBusyWeeks, getMyBusy, setMyBusy, DAYS } from "./happyschoolApi";

// GV tự khai báo lịch bận cho TỪNG tuần thời khoá biểu.
function buildSessions(pt) {
  let cur = 0;
  return (pt && pt.sessions ? pt.sessions : [
    { key: "S", label: "Sáng", periods: ["", "", "", "", ""] },
    { key: "C", label: "Chiều", periods: ["", "", "", "", ""] },
  ]).map((s) => {
    const periods = (s.periods || []).map((time, i) => ({ global: cur + i, label: `Tiết ${i + 1}`, time }));
    cur += (s.periods || []).length;
    return { key: s.key, label: s.label, periods };
  });
}

const HappySchoolMyBusy = ({ schoolId }) => {
  const [weeks, setWeeks] = useState([]);
  const [weekId, setWeekId] = useState("");
  const [sessions, setSessions] = useState([]);
  const [busy, setBusy] = useState(new Set());
  const [dirty, setDirty] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    getMyBusyWeeks(schoolId)
      .then((ws) => {
        setWeeks(ws || []);
        if (ws && ws.length) setWeekId(ws[0].id);
        else setLoading(false);
      })
      .catch((e) => { setError(e.message); setLoading(false); });
  }, [schoolId]);

  useEffect(() => {
    if (!schoolId || !weekId) return;
    setLoading(true); setError(""); setMsg(""); setDirty(false);
    getMyBusy(schoolId, weekId)
      .then((d) => {
        setSessions(buildSessions(d.periodTimes));
        setBusy(new Set(d.busy || []));
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId, weekId]);

  const week = weeks.find((w) => w.id === weekId);
  const readOnly = !!week && week.busyOpen !== true;

  const togglePeriod = (day, global) => {
    if (readOnly) return;
    setBusy((prev) => {
      const s = new Set(prev);
      const k = `${day}_${global}`;
      s.has(k) ? s.delete(k) : s.add(k);
      return s;
    });
    setDirty(true); setMsg("");
  };
  const toggleSession = (day, ses) => {
    if (readOnly) return;
    setBusy((prev) => {
      const s = new Set(prev);
      const keys = ses.periods.map((p) => `${day}_${p.global}`);
      const allBusy = keys.every((k) => s.has(k));
      keys.forEach((k) => (allBusy ? s.delete(k) : s.add(k)));
      return s;
    });
    setDirty(true); setMsg("");
  };
  const sessionBusyCount = (day, ses) => ses.periods.filter((p) => busy.has(`${day}_${p.global}`)).length;

  const save = async () => {
    if (readOnly) return;
    setSaving(true); setError(""); setMsg("");
    try {
      await setMyBusy(schoolId, weekId, Array.from(busy));
      setDirty(false); setMsg("Đã lưu lịch bận cho tuần này.");
    } catch (e) { setError(e.message); } finally { setSaving(false); }
  };

  return (
    <div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Đánh dấu buổi/tiết bạn <b>KHÔNG</b> thể dạy trong tuần đã chọn. Bấm ô "cả buổi" để tô/bỏ nhanh. Dữ liệu này được dùng khi nhà trường xếp thời khoá biểu cho tuần đó.
      </p>

      {weeks.length === 0 && !loading ? (
        <p style={{ color: "#b45309" }}>Chưa có tuần thời khoá biểu nào. Chờ nhà trường tạo tuần rồi khai báo.</p>
      ) : (
        <>
          <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#4b5563" }}>Tuần TKB:</span>
            <select value={weekId} onChange={(e) => setWeekId(e.target.value)} style={{ padding: 8, minWidth: 240 }}>
              {weeks.map((w) => (
                <option key={w.id} value={w.id}>
                  {(w.startDate || "?") + " → " + (w.endDate || "?")}{(w.khois && w.khois.length) ? ` (Khối ${w.khois.join(",")})` : ""}
                </option>
              ))}
            </select>
            {readOnly ? (
              <span style={{ fontSize: 12, color: "#6b7280", marginLeft: "auto", fontWeight: 600 }}>🔒 Tuần này đã đóng khai báo — chỉ xem, không sửa được</span>
            ) : (
              <>
                {dirty && <span style={{ fontSize: 12, color: "#b45309" }}>● Có thay đổi chưa lưu</span>}
                <button type="button" onClick={save} disabled={saving || !dirty} style={{ marginLeft: "auto", ...saveBtn, opacity: !dirty ? 0.5 : 1 }}>
                  {saving ? "Đang lưu..." : "💾 Lưu lịch bận"}
                </button>
              </>
            )}
          </div>

          {error && <p style={{ color: "#dc2626" }}>{error}</p>}
          {msg && <p style={{ color: "#059669" }}>{msg}</p>}

          {loading ? <p>Đang tải...</p> : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr>
                    <th style={thStyle}>Buổi / Tiết</th>
                    {DAYS.map((d) => (<th key={d} style={thStyle}>{d}</th>))}
                  </tr>
                </thead>
                <tbody>
                  {sessions.map((ses) => (
                    <React.Fragment key={ses.key}>
                      <tr>
                        <td style={{ ...thStyle, textAlign: "left" }}>{ses.label} — cả buổi</td>
                        {DAYS.map((_, day) => {
                          const cnt = sessionBusyCount(day, ses);
                          const full = cnt === ses.periods.length && cnt > 0;
                          return (
                            <td key={day} onClick={() => toggleSession(day, ses)}
                              style={{ ...tdStyle, cursor: readOnly ? "default" : "pointer", fontWeight: 700, background: full ? "#fca5a5" : cnt > 0 ? "#fde68a" : "#e5f5ea" }}
                              title={readOnly ? "Chỉ xem" : "Bấm để tô/bỏ cả buổi"}>
                              {full ? "Bận" : cnt > 0 ? `${cnt}/${ses.periods.length}` : ""}
                            </td>
                          );
                        })}
                      </tr>
                      {ses.periods.map((p) => (
                        <tr key={p.global}>
                          <td style={{ ...tdStyle, textAlign: "left", color: "#6b7280", paddingLeft: 22 }}>
                            {ses.label[0]}·{p.label} {p.time ? <span style={{ fontSize: 11 }}>{p.time}</span> : null}
                          </td>
                          {DAYS.map((_, day) => {
                            const isBusy = busy.has(`${day}_${p.global}`);
                            return (
                              <td key={day} onClick={() => togglePeriod(day, p.global)}
                                style={{ ...tdStyle, cursor: readOnly ? "default" : "pointer", background: isBusy ? "#fecaca" : "#f0fdf4" }}
                                title={readOnly ? "Chỉ xem" : isBusy ? "Bận (bấm bỏ)" : "Rảnh (bấm đánh dấu bận)"}>
                                {isBusy ? "Bận" : ""}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {week && <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 10 }}>Tuần: {week.startDate} → {week.endDate}</p>}
        </>
      )}
    </div>
  );
};

const saveBtn = { padding: "6px 16px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 999, cursor: "pointer", fontSize: 13, fontWeight: 700 };
const thStyle = { border: "1px solid #e5e7eb", padding: "6px 10px", background: "#f9fafb", whiteSpace: "nowrap" };
const tdStyle = { border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center" };

export default HappySchoolMyBusy;
